import { render } from "./EmployeeHorarios.vue?vue&type=template&id=2b2eeab1&scoped=true&ts=true"
import script from "./EmployeeHorarios.vue?vue&type=script&lang=ts"
export * from "./EmployeeHorarios.vue?vue&type=script&lang=ts"

import "./EmployeeHorarios.vue?vue&type=style&index=0&id=2b2eeab1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b2eeab1"]])

export default __exports__